import React from "react";
import { Shuttle } from "@components/Shuttle";
import { StyledLandingSection } from "./styles";

const CIRCLES = [1, 1.4, 1.8, 2.2, 2.6, 3];

const Circle = ({ scale = 1, zIndex }) => {
  const size = scale * 400;
  return (
    <div
      className="center circle"
      style={{ width: size, height: size, zIndex }}
    ></div>
  );
};

const LandingSection: React.FC = ({}) => {
  return (
    <StyledLandingSection>
      <div className="content">
        <div className="intro">
          <h1 className="title">
            Hello there! <br />
            I'm Jason Li.
          </h1>
          <div className="divider" />
          <span className="sub-title">A Software Developer</span>
        </div>
        <div className="shuttle-container">
          <div className="center shuttle">
            <Shuttle className="core" />
            <div className="trails">
              <div className="trail trail-1" />
              <div className="trail trail-2" />
              <div className="trail trail-3 trail-back" />
              <div className="trail trail-3-drop trail-back" />
              <div className="trail trail-4" />
              <div className="trail trail-4-drop" />
              <div className="trail trail-5 trail-back" />
              <div className="trail trail-6" />
              <div className="trail trail-7" />
            </div>
          </div>
          {CIRCLES.map((scale, index) => (
            <Circle
              key={`circle-${index}`}
              scale={scale}
              zIndex={`${CIRCLES.length - index}`}
            />
          ))}
        </div>
      </div>
    </StyledLandingSection>
  );
};

export default LandingSection;
